import React from 'react';

const ClientCaseDetailsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-800">Case Details Page</h1>
        <p className="text-gray-600 mt-2">Under construction</p>
      </div>
    </div>
  );
};

export default ClientCaseDetailsPage;